(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  var coll = document.getElementsByClassName("collapsible");

  for (let i = 0; i < coll.length; i++) {
    coll[i].childNodes[1].addEventListener("click", function() {
      this.classList.toggle("active");
      var answer = this.nextElementSibling;
      var caret = this.getElementsByClassName("question-caret")[0]
      if (answer.style.maxHeight){
        answer.style.maxHeight = null;
      } else {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }

      if (caret.style.transform) {
        caret.style.transform = null
      } else{
        caret.style.transform = "rotate(180deg)"
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
